export default "__VITE_ASSET__BnxHc2yY__"